
import React from 'react';

// Shared components
import { AccordionComponent, OmniIconComponent, OmniTooltipNextComponent } from '../../../../shared';

export class OverAllBudgetComponent extends React.Component {

    defaultState = {
        budgetTableData: [],
    }

    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
            this.updateBudgetTableData()
        }
    }

    /**
     * Updates the budget table data by aggregating data from online and print sources,
     * updating their status columns, formatting amounts as currency strings, and setting
     * the state with the new budget table data.
     *
     * @method updateBudgetTableData
     */
    updateBudgetTableData() {
        const budgetTableData = [{ title: '', netMedia: 'MOH Net Media', totalMedia: 'MOH Total Media', amountSent: 'Amount Sent', planningSystemAmount: 'Planning System Amount', mediaOceanBudget: 'Buying System Amount', status: 'Status' }];
        let onlineTableObj = this.getDataForTable(this.props?.onlineArr, 'Online');
        let printTableObj = this.getDataForTable(this.props?.printArr, 'Print');
        onlineTableObj = this.updateStatusColumn(onlineTableObj);
        printTableObj = this.updateStatusColumn(printTableObj);
        let currancyName = this.props?.isLocal && this.props?.currencyName ? this.props.currencyName : 'USD'
        let tableObj = {
            title: 'Total',
            netMedia: (onlineTableObj.netMedia + printTableObj.netMedia),
            totalMedia: (onlineTableObj.totalMedia + printTableObj.totalMedia),
            amountSent: (onlineTableObj.amountSent + printTableObj.amountSent),
            mediaOceanBudget: (onlineTableObj.mediaOceanBudget + printTableObj.mediaOceanBudget),
            planningSystemAmount: (onlineTableObj.planningSystemAmount + printTableObj.planningSystemAmount)
        };
        tableObj['status'] = this.getTotalStatusColumn(onlineTableObj, printTableObj);
        tableObj['tooltipMessage'] = this.updateTooltipMessage(tableObj)
        let totalTableObj = this.updateAmountsAsCurrencyStrings({ ...tableObj }, currancyName);
        printTableObj = this.updateAmountsAsCurrencyStrings(printTableObj, currancyName);
        onlineTableObj = this.updateAmountsAsCurrencyStrings(onlineTableObj, currancyName);


        budgetTableData.push(totalTableObj, onlineTableObj, printTableObj);
        this.setState({ budgetTableData }, () => {
            this.props.updateTotalInOverallBudget(tableObj)
        });
    }

    updateStatusColumn(obj) {
        if (obj.amountSent === 0) {
            obj.status = 'Not Synced';
            return obj;
        }

        if (obj.mediaOceanBudget === obj.planningSystemAmount && obj.planningSystemAmount === obj.totalMedia) {
            obj.status = 'Sync Successful';
        } else {
            obj.status = 'Sync Error';
            obj['tooltipMessage'] = this.updateTooltipMessage(obj);
        }

        return obj;
    }

    updateTooltipMessage(obj) {
        if (obj?.status === 'Sync Error') {
            return 'Please update in Planning System if incorrect, If MOH is incorrect please make adjustments in the MOH as necessary';
        }
        return '';
        // below code is required after the backend sync is updated with mediaocean budget
        // let tooltipMessage = '';

        // const { totalMedia, mediaOceanBudget, planningSystemAmount } = obj;

        // if (totalMedia !== mediaOceanBudget && totalMedia !== planningSystemAmount && mediaOceanBudget !== planningSystemAmount) {
        //     // All three are different
        //     tooltipMessage = 'Please adjust in planit and after updating in planit select needs update, please select correct channels and send it to media ocean';
        // }
        // if (totalMedia === mediaOceanBudget && totalMedia !== planningSystemAmount) {
        //     // Total Media and Buying System Amount are equal, but Planning System Amount is different
        //     tooltipMessage = 'Please adjust in planit and after updating in planit select needs update';
        // }

        // if (totalMedia === planningSystemAmount && totalMedia !== mediaOceanBudget) {
        //     // Total Media and Planning System Amount are equal, but Buying System Amount is different
        //     tooltipMessage = 'Please select correct channels and send it to media ocean';
        // }

        // if (mediaOceanBudget === planningSystemAmount && mediaOceanBudget !== totalMedia) {
        //     // Buying System Amount and Planning System Amount are equal, but Total Media is different
        //     tooltipMessage = 'Amounts do not match between Planning System, MOH and the Buying System';
        // }

        // return tooltipMessage;
    }

    /**
     * Determines the overall status by comparing the status of online and print table objects.
     *
     * The method performs the following checks:
     * 1. If both `onlineTableObj` and `printTableObj` have a status of 'Sync Successful', returns 'Sync Successful'.
     * 2. If both `onlineTableObj` and `printTableObj` have a status of 'Not Synced', returns 'Not Synced'.
     * 3. If either `onlineTableObj` or `printTableObj` has a status of 'Sync Error', returns 'Sync Error'.
     * 4. If either `onlineTableObj` or `printTableObj` has a status of 'Sync Successful' and neither has a status of 'Sync Error', returns 'Sync Successful'.
     * 5. If none of the above conditions are met, returns an empty string.
     *
     * @param {Object} onlineTableObj - The object representing the online table data.
     * @param {string} onlineTableObj.status - The status of the online table.
     * @param {Object} printTableObj - The object representing the print table data.
     * @param {string} printTableObj.status - The status of the print table.
     * @returns {string} The overall status based on the comparison of the online and print table statuses.
     */
    getTotalStatusColumn(onlineTableObj, printTableObj) {
        if (onlineTableObj.status === 'Sync Successful' && printTableObj.status === 'Sync Successful') {
            return 'Sync Successful';
        } else if (onlineTableObj.status === 'Not Synced' && printTableObj.status === 'Not Synced') {
            return 'Not Synced';
        } else if (onlineTableObj.status === 'Sync Error' || printTableObj.status === 'Sync Error') {
            return 'Sync Error';
        } else if ((onlineTableObj.status === 'Sync Successful' || onlineTableObj.status === 'Sync Successful') &&
            (printTableObj.status !== 'Sync Error' && printTableObj.status !== 'Sync Error')) {
            return 'Sync Successful';
        } else {
            return '';
        }
    }

    /**
     * Converts the numerical values of `netMedia`, `totalMedia`, and `amountSent` properties of the given object to currency strings.
     *
     * The method uses the `toLocaleString` function to format the numbers as currency strings in USD.
     *
     * @param {Object} obj - The object containing `netMedia`, `totalMedia`, and `amountSent` properties.
     * @param {number} obj.netMedia - The net media value.
     * @param {number} obj.totalMedia - The total media value.
     * @param {number} obj.amountSent - The amount sent.
     * @returns {Object} The updated object with the formatted currency strings.
     */
    updateAmountsAsCurrencyStrings(obj, currancyName) {
        obj.netMedia = obj.netMedia?.toLocaleString('en-US', { style: "currency", currency: currancyName })
        obj.totalMedia = obj.totalMedia?.toLocaleString('en-US', { style: "currency", currency: currancyName })
        obj.amountSent = obj.amountSent?.toLocaleString('en-US', { style: "currency", currency: currancyName })
        obj.mediaOceanBudget = obj.mediaOceanBudget?.toLocaleString('en-US', { style: "currency", currency: currancyName })
        obj.planningSystemAmount = obj.planningSystemAmount?.toLocaleString('en-US', { style: "currency", currency: currancyName })

        return obj;
    }

    /**
     * Generates a table data object with the specified title and calculated totals for `netMedia`, `totalMedia`, and `amountSent`.
     *
     * The method calculates the totals using the `calculateTotals` method and returns an object with the title and calculated totals.
     *
     * @param {Array} data - The array of data to calculate totals from.
     * @param {string} title - The title for the table data.
     * @returns {Object} The table data object containing the title and calculated totals.
     * @returns {string} return.title - The title for the table data.
     * @returns {number} return.netMedia - The calculated net media total.
     * @returns {number} return.totalMedia - The calculated total media amount.
     * @returns {number} return.amountSent - The calculated amount sent.
     */
    getDataForTable(data, title) {
        const totals = this.calculateTotals(data);

        return {
            title: title,
            netMedia: totals.netMedia,
            totalMedia: totals.totalAmount,
            amountSent: totals.amountSent,
            mediaOceanBudget: totals?.mediaOceanBudget ? totals?.mediaOceanBudget : 0,
            planningSystemAmount: totals?.planningSystemAmount ? totals?.planningSystemAmount : 0
        };
    }

    /**
     * Calculates the totals for `netMedia`, `totalAmount`, and `amountSent` from the given data array.
     *
     * The method iterates over the data array and accumulates the values of `budget`, `totalBudget`, and `amount_sent` properties.
     *
     * @param {Array} data - The array of data objects to calculate totals from.
     * @param {Object} data[].budget - The budget value of the data element.
     * @param {Object} data[].totalBudget - The total budget value of the data element.
     * @param {Object} data[].amount_sent - The amount sent value of the data element.
     * @returns {Object} The object containing the calculated totals.
     * @returns {number} return.netMedia - The calculated net media total.
     * @returns {number} return.totalAmount - The calculated total amount.
     * @returns {number} return.amountSent - The calculated amount sent.
     */
    calculateTotals(data) {
        return data.reduce((acc, element) => {
            let budgetKey = 'channel_total_budget_by_placements'
            let amountSentKey = 'amount_sent'
            let mediaOceanBudgetKey = 'mediaocean_budget'
            let planningSystemAmountKey = 'channel_total_budget_in_pmds'
            let feeAmountKey = 'channel_fees'
            if (this.props?.isLocal && this.props?.currencyName) {
                budgetKey = 'channel_total_budget_by_placements_local'
                amountSentKey = 'amount_sent_local';
                mediaOceanBudgetKey = 'mediaocean_budget_local';
                planningSystemAmountKey = 'channel_total_budget_in_pmds_local',
                    feeAmountKey = 'channel_fees_local'
            }
            return {
                netMedia: Number(acc.netMedia) + (Number(element?.[budgetKey]) || 0),
                totalAmount: Number(acc.totalAmount) + (Number(element?.[budgetKey]) || 0) + (Number(element?.[feeAmountKey]) || 0),
                amountSent: Number(acc.amountSent) + (Number(element?.[amountSentKey]) || 0),
                mediaOceanBudget: Number(acc.mediaOceanBudget) + (Number(element?.[mediaOceanBudgetKey]) || 0),
                planningSystemAmount: Number(acc.planningSystemAmount) + (Number(element?.[planningSystemAmountKey]) || 0),

            }
        }, { netMedia: 0, totalAmount: 0, amountSent: 0, mediaOceanBudget: 0, planningSystemAmount: 0 });
    }

    /**
     * Returns the CSS class name based on the given status.
     *
     * The method appends a specific class name to the base class 'data-in-table' based on the status value.
     *
     * @param {string} status - The status to determine the class name.
     * @returns {string} The CSS class name corresponding to the given status.
     */
    getStatusClassName(status) {
        const statusClass = 'data-in-table ';
        if (status === 'Sync Successful') {
            return statusClass + 'success-status-color';
        } else if (status === 'Sync Error') {
            return statusClass + 'error-status-color';
        }
        return statusClass;
    }

    render() {
        return <div className="overall-budget-container">
            <AccordionComponent accordion={{ header: 'Overall Budget', isOpen: true }}>
                <div className="layout-container">
                    {this.state.budgetTableData.map((row, index) => (
                        <div key={index} className={`row ${index === 0 ? 'header-row' : ''}`}>
                            <div className="cell">{row.title}</div>
                            <div className="cell" style={{ width: '150px' }}>{row.netMedia}</div>
                            <div className="cell" style={{ width: '150px' }}>{row.totalMedia}</div>
                            <div className="cell">{row.amountSent}</div>
                            {/* <div className="cell" style={{ width: '200px' }}>{row.mediaOceanBudget}</div> */}
                            <div className="cell" style={{ width: '200px' }}>{row.planningSystemAmount}</div>
                            <div className="cell">
                                {row?.tooltipMessage ?

                                    <div>
                                        {row.status}
                                        <OmniTooltipNextComponent>
                                            <div slot='invoker' aria-haspopup='true'>

                                                <OmniIconComponent className="infoIcon" icon-id="omni:informative:info"></OmniIconComponent>
                                            </div>
                                            <div slot='content'>{row.tooltipMessage}</div>
                                        </OmniTooltipNextComponent>
                                    </div>

                                    :
                                    <>{row.status}</>
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </AccordionComponent>
        </div>
    }
}